import {
  Home,
  Competitions,
  Teams,
  Archers,
  Referees,
  Ranks,
  News,
  Leaders,
  Ranking,
  Erembe,
  Privacy,
  AuditLogs,
  Admins
} from "../pages";

export const routes = [
  {
    path: "/",
    key: "home",
    component: <Home />,
    label: "Нүүр",
    showHeader: true,
    icon: "HomeOutlined"
  },
  {
    path: "/competitions",
    key: "competitions",
    component: <Competitions />,
    label: "Тэмцээнүүд",
    showHeader: true,
    icon: "TrophyOutlined"
  },
  {
    path: "/teams",
    key: "teams",
    component: <Teams />,
    label: "Багууд",
    showHeader: true,
    icon: "TeamOutlined"
  },
  {
    path: "/referees",
    key: "referees",
    component: <Referees />,
    label: "Шүүгчид",
    showHeader: true,
    icon: "SafetyCertificateOutlined"
  },
  {
    path: "/leaders",
    key: "leaders",
    component: <Leaders />,
    label: "Багийн ахлагчид",
    showHeader: true,
    icon: "CrownOutlined"
  },
  {
    path: "/archers",
    key: "archers",
    component: <Archers />,
    label: "Харваачид",
    showHeader: true,
    icon: "UserOutlined"
  },
  {
    path: "/ranks",
    key: "ranks",
    component: <Ranks />,
    label: "Цол",
    showHeader: true,
    icon: "StarOutlined"
  },
  {
    path: "/news",
    key: "news",
    component: <News />,
    label: "Мэдээ",
    showHeader: true,
    icon: "NotificationOutlined"
  },
  {
    path: "/rankings",
    key: "rankings",
    component: <Ranking />,
    label: "Чансаа",
    showHeader: true,
    icon: "BarChartOutlined"
  },
  {
    path: "/erembe",
    key: "erembe",
    component: <Erembe />,
    label: "Эрэмбэ",
    showHeader: true,
    icon: "OrderedListOutlined"
  },
  {
    path: "/audit-logs",
    key: "audit-logs",
    component: <AuditLogs />,
    label: "Аудит Лог",
    showHeader: true,
    icon: "FileTextOutlined",
    adminOnly: true
  },
  {
    path: "/admins",
    key: "admins",
    component: <Admins />,
    label: "Админ хэрэглэгчид",
    showHeader: true,
    icon: "UserSwitchOutlined",
    superAdminOnly: true
  },
  {
    path: "/privacy-policy",
    key: "privacy",
    component: <Privacy />,
    label: "Тохиргоо",
    showHeader: true,
    icon: "SettingOutlined",
    superAdminOnly: true
  }
];
